import * as dressageActions from './actions';
import {ActionType, getType} from 'typesafe-actions';
import {DressageProtocolListState, JsonDressageProtocolListItem} from './types';
import DateUtils from "../../utils/Date.utils";
import DressageProtocolListItem from "../../domain/DressageProtocolListItem";
import {DressageProtocolCategory} from "../../domain/DressageProtocolCategory";

const defaultState: DressageProtocolListState = {
  dressageProtocols: [],
  lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp()
};

export default (state = defaultState, action: ActionType<typeof dressageActions>): DressageProtocolListState => {
  switch (action.type) {
    case getType(dressageActions.fetchDressageProtocols.success):
      let dressageProtocols: JsonDressageProtocolListItem[] = action.payload;
      return {
        ...state,
        lastUpdatedTimeStamp: DateUtils.getNowAsTimeStamp(),
        dressageProtocols: dressageProtocols.map((p: JsonDressageProtocolListItem) => toDressageProtocol(p))
      };
    default:
      return state;
  }
}

function toDressageProtocol(json: JsonDressageProtocolListItem) {
  return new DressageProtocolListItem(
    json.id,
    mapDressageProtocolCategory(json.category),
    json.horse,
    json.series,
    json.protocolNumber,
    json.period
  );
}

function mapDressageProtocolCategory(category: string): DressageProtocolCategory {
  switch (category) {
    case "INDIVIDUAL":
      return "INDIVIDUAL";
    case "GROUP":
      return "GROUP";
    case "YOUNG":
      return "YOUNG";
    case "EVENTING":
      return "EVENTING";
    default:
      let message = category + " not yet supported";
      console.error(message);
      return "INDIVIDUAL"
  }
}


